/** Lazy Load View **/
function loadView(view) {
	return () => import(/* webpackChunkName: "view-[request]" */ `@/modules/activityReport/_components/${view}.vue`)
}

let routes = [
	{
		path: 'activity-report',
		name: 'activity-report',
		component: loadView('index'),
		meta: {
			auth: true
		}
	}
];

export default routes;